import { takeLatest, put, all, call } from "redux-saga/effects";

import LenderActionTypes from "./lender.types";
import {
  lenderDetailsAdd,
  lenderDetailsUpdate,
  lenderListGet,
  lenderDetailsFetch,
  lenderDetailsDelete,
  fetchListLender,
} from "./lender.service";

import {
  addLenderDetailsSuccess,
  addLenderDetailsFailure,
  addLenderDetailsResponseChanged,
  updateLenderDetailsSuccess,
  updateLenderDetailsFailure,
  updateLenderDetailsResponseChanged,
  getLenderListSuccess,
  getLenderListFailure,
  getLenderListResponseChanged,
  fetchLenderDetailsSuccess,
  fetchLenderDetailsFailure,
  fetchLenderDetailsResponseChanged,
  deleteLenderDetailsSuccess,
  deleteLenderDetailsFailure,
  deleteLenderDetailsResponseChanged,
  lenderListFetchFailure,
  lenderListFetchSuccess,
  lenderListFetchResponseChanged,
} from "./lender.action";
import { encryptData } from "../../_common/enode-decode";

/** *********************  START GET LENDER LIST  ******************** */
export function* lenderDetailsListGet({ payload }: any) {
  const { CompanyID, searchValueSet, limit, InstanceName } = payload;
  try {
    const key = "GetAllLenderPaginationKey";
    const jsonData = {
      CompanyID: CompanyID,
      InputSearch: searchValueSet,
      Limit: limit,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(lenderListGet, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(getLenderListFailure(responseData.data));
    } else {
      yield put(getLenderListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(getLenderListFailure(error));
  }
}

export function* resetGetLenderListResponse() {
  yield put(getLenderListResponseChanged());
}

export function* onGetLenderListDetails() {
  yield takeLatest(
    LenderActionTypes.GET_LENDER_LIST_START,
    lenderDetailsListGet,
  );
}

export function* onGetLenderListResponseReset() {
  yield takeLatest(
    LenderActionTypes.GET_LENDER_LIST_RESPONSE_RESET,
    resetGetLenderListResponse,
  );
}
/** *********************  END GET LENDER LIST ******************** */

/** *********************  START ADD LENDER DETAILS  ******************** */
export function* createLender({ payload }: any) {
  const { LenderName, CompanyID, UserName, UserID, InstanceName } = payload;
  try {
    const key = "CreateLenderKey";
    const jsonData = {
      LenderName: LenderName,
      CompanyID: CompanyID,
      UserName: UserName,
      CreatedBy: UserID,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(lenderDetailsAdd, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(addLenderDetailsFailure(responseData.data));
    } else {
      yield put(addLenderDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(addLenderDetailsFailure(error));
  }
}

export function* resetAddLenderResponse() {
  yield put(addLenderDetailsResponseChanged());
}

export function* onCreateLenderDetails() {
  yield takeLatest(LenderActionTypes.ADD_LENDER_DETAILS_START, createLender);
}

export function* onCreateLenderResponseReset() {
  yield takeLatest(
    LenderActionTypes.ADD_LENDER_DETAILS_RESPONSE_RESET,
    resetAddLenderResponse,
  );
}
/** *********************  END ADD LENDER DETAILS ******************** */

/** *********************  START UPDATE LENDER DETAILS  ******************** */
export function* lenderUpdate({ payload }: any) {
  const {
    LenderID,
    LenderName,
    oldLenderName,
    CompanyID,
    UserName,
    UserID,
    InstanceName,
  } = payload;
  try {
    const key = "UpdateLenderKey";
    const jsonData = {
      LenderID: LenderID,
      LenderName: LenderName,
      OldLenderName: oldLenderName,
      CompanyID: CompanyID,
      UserName: UserName,
      UpdatedBy: UserID,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(lenderDetailsUpdate, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(updateLenderDetailsFailure(responseData.data));
    } else {
      yield put(updateLenderDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(updateLenderDetailsFailure(error));
  }
}

export function* resetUpdateLenderDetailsResponse() {
  yield put(updateLenderDetailsResponseChanged());
}

export function* onUpdateLenderDetails() {
  yield takeLatest(LenderActionTypes.UPDATE_LENDER_DETAILS_START, lenderUpdate);
}

export function* onUpdateLenderResponseReset() {
  yield takeLatest(
    LenderActionTypes.UPDATE_LENDER_DETAILS_RESPONSE_RESET,
    resetUpdateLenderDetailsResponse,
  );
}
/** *********************  END UPDATE LENDER DETAILS ******************** */

/** *********************  START DELETE LENDER DETAILS  ******************** */
export function* lenderDelete({ payload }: any) {
  try {
    const key = "DeleteLenderKey";
    const jsonData = {
      CompanyID: payload.CompanyID,
      LenderID: payload.LenderID,
      LenderName: payload.LenderName,
      DeletedBy: payload.UserID,
      UserName: payload.UserName,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(lenderDetailsDelete, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(deleteLenderDetailsFailure(responseData.data));
    } else {
      yield put(deleteLenderDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(deleteLenderDetailsFailure(error));
  }
}

export function* resetDeleteLenderDetailsResponse() {
  yield put(deleteLenderDetailsResponseChanged());
}

export function* onDeleteLenderDetail() {
  yield takeLatest(LenderActionTypes.DELETE_LENDER_DETAILS_START, lenderDelete);
}

export function* onDeleteLenderResponseReset() {
  yield takeLatest(
    LenderActionTypes.DELETE_LENDER_DETAILS_RESPONSE_RESET,
    resetDeleteLenderDetailsResponse,
  );
}
/** *********************  END DELETE LENDER DETAILS ******************** */

/** *********************  START FETCH LENDER DETAILS  ******************** */
export function* fetchLenderData({ payload }: any) {
  try {
    const key = "FetchLenderKey";
    const jsonData = {
      CompanyID: payload.CompanyID,
      LenderID: payload.LenderID,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(lenderDetailsFetch, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(fetchLenderDetailsFailure(responseData.data));
    } else {
      yield put(fetchLenderDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(fetchLenderDetailsFailure(error));
  }
}

export function* resetFetchLenderDetailsResponse() {
  yield put(fetchLenderDetailsResponseChanged());
}

export function* onFetchLenderDetails() {
  yield takeLatest(
    LenderActionTypes.FETCH_LENDER_DETAILS_START,
    fetchLenderData,
  );
}

export function* onFetchLenderResponseReset() {
  yield takeLatest(
    LenderActionTypes.FETCH_LENDER_DETAILS_RESPONSE_RESET,
    resetFetchLenderDetailsResponse,
  );
}
/** *********************  END FETCH LENDER DETAILS ******************** */

/** *********************** START LENDER FETCH LIST ************************ */
export function* lenderListFetch({ payload }: any) {
  const key: any = "AllLenderMasterKey";
  try {
    const jsonData: any = {
      CompanyID: payload.CompanyID,
      InstanceName: payload.InstanceName,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(fetchListLender, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(lenderListFetchFailure(responseData.data));
    } else {
      yield put(lenderListFetchSuccess(responseData.data));
    }
  } catch (error) {
    yield put(lenderListFetchFailure(error));
  }
}

export function* lenderFetchResponseReset() {
  yield put(lenderListFetchResponseChanged());
}

export function* onFetchListLenders() {
  yield takeLatest(LenderActionTypes.LENDER_LIST_FETCH_START, lenderListFetch);
}

export function* onLenderListFetchResponseReset() {
  yield takeLatest(
    LenderActionTypes.LENDER_LIST_RESPONSE_RESET_START,
    lenderFetchResponseReset,
  );
}
/** *********************** END LENDER FETCH LIST ************************ */

export function* lenderMasterSaga() {
  yield all([
    call(onCreateLenderDetails),
    call(onCreateLenderResponseReset),
    call(onUpdateLenderDetails),
    call(onUpdateLenderResponseReset),
    call(onGetLenderListDetails),
    call(onGetLenderListResponseReset),
    call(onFetchLenderDetails),
    call(onFetchLenderResponseReset),
    call(onDeleteLenderDetail),
    call(onDeleteLenderResponseReset),
    call(onFetchListLenders),
    call(onLenderListFetchResponseReset),
  ]);
}
